import { memo, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useZebraPrinter } from '../../Context/ZebraPrinterContext';
import { MainContext } from '../../Context/MainContext';
import { useWebSocket } from '../../Context/WsContext';
import REQUEST from '../../modules/request';

const servidor = JSON.parse(sessionStorage.getItem('projeto'))?.servidor || JSON.parse(sessionStorage.getItem('user'))?.servidor;
const cod_cd = JSON.parse(sessionStorage.getItem('user'))?.cod_cd || JSON.parse(sessionStorage.getItem('cd'))?.cod_cd;

let interval = null;

const ImpressaoComponent = () => {

    const { connectPrinter, testConnection, printEtiquetas, isConnected: isConnectedZ } = useZebraPrinter();
    const { setStatus, setAlert } = useContext(MainContext);
    const [loading, setLoading] = useState(false);
    const [active, setActive] = useState(false);
    const [error, setError] = useState(false);
    const { emitEvent } = useWebSocket();

    // const onNewEndereco = useRef((endereco) => {
    //     printEtiquetas([endereco]).then(() => {
    //         emitEvent('print_done', endereco.codbarras, endereco.cod_cd, servidor);
    //         console.log('deletando.');
    //     });
    // });

    useEffect(() => {
        if(error) setTimeout(() => {
            setError(false);
        }, 2000);
    }, [error]);

    useEffect(() => {
        if((!isConnectedZ) && active) setActive(false);
    }, [isConnectedZ]);

    const listarFila = useCallback(() => {
        const onError = (error) => {
            clearInterval(interval);
            interval = null;
            setError(true);
            setStatus(error);
        };

        REQUEST.put('/etiquetas/fila')
            .then(({ data: etiquetas }) => {
                printEtiquetas(etiquetas).then(() => {
                    etiquetas.forEach(({ codbarras }) => {
                        emitEvent('print_done', codbarras, cod_cd, servidor);
                    });
                }, () => onError('A impressora foi desconectada. Verifique a impressora e o Zebra Browser Print.'));
            })
            .catch(error => {
                if(error?.response?.status !== 404) onError(error);
            });
    }, []);

    const handleClick = useCallback(async () => {
        if(!active){
            const connect = isConnectedZ ? testConnection : connectPrinter;
            try {
                setLoading(true);
                await connect();
                // await addEvent('print', onNewEndereco.current);
                await REQUEST.put('/etiquetas/fila')
                    .then(({ data: etiquetas }) => {
                        printEtiquetas(etiquetas).then(() => {
                            etiquetas.forEach(({ codbarras }) => {
                                emitEvent('print_done', codbarras, cod_cd, servidor);
                            });
                        });
                    })
                    .catch(error => {
                        if(error?.response?.status !== 404) throw error;
                    })
                    .then(() => setLoading(false));
                interval = setInterval(listarFila, 10000);
                setActive(true);
            } catch(error) {
                if(error === 'install') setAlert('O Zebra Browser Print está desligado ou não está instalado no sistema. Deseja instalar?', () => window.open('https://www.zebra.com/us/en/support-downloads/hdn/browser-print-eula.html'));
                else setStatus(error);
                clearInterval(interval);
                interval = null;
                setError(true);
                setLoading(false);
            }
        }
        else {
            // await removeEvent('print', onNewEndereco.current);
            clearInterval(interval);
            interval = null;
            setActive(false);
        }
    }, [active]);

    return (
        <button className={`btn btn-${error ? 'danger' : active ? 'primary' : 'light'} me-2`} disabled={loading} title='Habilitar impressão de etiquetas' onClick={handleClick}>
            <i className='bi bi-printer-fill' />
        </button>
    );
};
const Impressao = memo(ImpressaoComponent);

export default Impressao;